import { appendSpinnerToFormButtons } from "../../common/spinner"
import { EmailInput } from "../identity_bundle/email_input"

class RecoverPasswordPage {

    private readonly $documentObject: Document

    constructor(documentObject: Document) {
        this.$documentObject = documentObject
        this.initEmailValidation()
    }

    private initEmailValidation() {
        const inputEmailValidation = new EmailInput(document)
        inputEmailValidation.registerEventListeners()
    }

    registerSubmitButtonSpinner() {
        appendSpinnerToFormButtons(this.$documentObject, ".fti_js_recoverPassword_emailForm")
    }
}

export default RecoverPasswordPage
